// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2zJXj","footer":"ModalInfo_footer__1Q_Ge"};